import { useEffect, useState } from "react";
import { api } from "@/api/client";
import { READ_ONLY_TITLE, useReadOnly, useStore } from "@/state/store";

export function TeamSummaryOverlay() {
  const { state, dispatch } = useStore();
  const readOnly = useReadOnly();
  const [data, setData] = useState<Awaited<ReturnType<typeof api.admin.teamSummary>> | null>(null);

  useEffect(() => {
    let cancelled = false;
    const load = async () => {
      try {
        const r = await api.admin.teamSummary(state.auth.token);
        if (!cancelled) setData(r);
      } catch {
        /* noop */
      }
    };
    load();
    const id = setInterval(load, 4000);
    return () => {
      cancelled = true;
      clearInterval(id);
    };
  }, [state.auth.token]);

  const goWorking = async () => {
    const p = await api.phase.set(state.auth.token, "working");
    dispatch({ type: "phase/set", phase: p });
  };

  const teams = data?.teams ?? [];
  const total = data?.totalAssigned ?? 0;

  return (
    <div className="teams-root">
      <div className="deck-bg" aria-hidden="true" />

      <header className="rise rise-1" style={{ textAlign: "center" }}>
        <div className="deck-eyebrow" style={{ color: "var(--svo-blau)" }}>
          Workshop · Teams stehen fest
        </div>
        <h1
          className="deck-title"
          style={{
            color: "var(--svo-weiss)",
            fontSize: "clamp(2.25rem, 4.5vw, 3.5rem)",
            margin: "8px 0 0",
          }}
        >
          {teams.length} Teams · {total} Teilnehmer
        </h1>
      </header>

      <div className="teams-grid">
        {teams.map((t, i) => (
          <div key={t.number} className={`team-card rise rise-${Math.min(i + 2, 6)}`}>
            <div className="team-num">Team {t.number}</div>
            <div className="team-count">
              <strong>{t.count}</strong>
              <span>{t.count === 1 ? "Person" : "Personen"}</span>
            </div>
          </div>
        ))}
        {teams.length === 0 && (
          <div className="team-empty rise rise-2">Noch keine Teams verteilt.</div>
        )}
      </div>

      <div className="teams-foot rise rise-6">
        <div className="teams-foot-info">
          Auf jedem Handy steht die Team-Nummer. Die Teams können sich finden.
        </div>
        <button
          type="button"
          className={`btn btn-success teams-cta${readOnly ? " is-readonly" : ""}`}
          onClick={goWorking}
          disabled={readOnly}
          title={readOnly ? READ_ONLY_TITLE : undefined}
        >
          → Arbeitsphase öffnen
        </button>
      </div>
    </div>
  );
}
